import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "technical-form" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "type" }
const _hoisted_9 = {
  key: 0,
  class: "empty"
}

import { computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import { svgIcon, baseInput } from "@/common/components";

import { laboratoryList } from "@/common/api/rest/laboratory";

import type { LaboratoryListType } from "@/common/types/laboratory";


export default /*@__PURE__*/_defineComponent({
  __name: 'laboratory',
  props: {
    title: {},
    account_id: {},
    ids: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const selecteds = ref<any[]>([]);
const listData = ref<LaboratoryListType[]>([]);
const inputSearch = ref<string | null>("");

function search() {
  if (!props.account_id) return;

  laboratoryList(props.account_id, {
    search: inputSearch.value as string,
    limit: 500,
    page: 0,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        listData.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function select(data: any) {
  if (props.ids?.includes(data.laboratory_id)) return;

  if (selecteds.value.find((sl) => sl.laboratory_id === data.laboratory_id)) {
    selecteds.value = selecteds.value.filter(
      (sl) => sl.laboratory_id !== data.laboratory_id,
    );
  } else {
    selecteds.value.push(data);
  }

  emit("update-data", selecteds.value);
}

onMounted(() => {
  search();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(baseInput), {
        modelValue: inputSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
        background: "#fff",
        color: "#000",
        placeholder: _unref(t)('common.labels.search'),
        "onKey:enter": _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, {
        sufix: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(svgIcon), {
              icon: "search",
              size: "1.75rem",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (search()))
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", {
            active: selecteds.value.find(
              (sl) => sl.laboratory_id === item.laboratory_id,
            ),
            disabled: __props.ids?.find((id) => id === item.laboratory_id),
          }]),
          onClick: ($event: any) => (select(item))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(item.document_name) + " - " + _toDisplayString(item.document_number), 1)
        ], 10, _hoisted_6))
      }), 128)),
      (listData.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})